module.exports = __webpack_public_path__ + "img/house.661bc7ef.png";